import parse from 'utils/parse';

import { ApiStep } from './contracts';

const makeTestId = (...ids: string[]): string => parse.toTestId('signup', ...ids);

const testId = Object.freeze({
  page: makeTestId(),
  skeleton: makeTestId('skeleton'),
  breadcrumb: makeTestId('breadcrumb'),
  email: makeTestId('email'),
  agreementCheckbox: makeTestId('agreement-checkbox'),
  name: makeTestId('name'),
  displayName: makeTestId('display-name'),
  dateOfBirth: makeTestId('date-of-birth'),
  phoneNumber: makeTestId('phone-number'),
  phoneNumberHint: makeTestId('phone-number-helper-text'),
  password: makeTestId('password'),
  idNumber: makeTestId('id-number'),
  documentExpiryCheckbox: makeTestId('document-expiry-checkbox'),
  idExpirationDate: makeTestId('id-expiration-date'),
  idAgreement: makeTestId('id-agreement'),
  biometricConsent: makeTestId('biometric-consent'),
  referredBy: makeTestId('referred-by'),
});

const layoutInitialHeight = 350;

const restrictedCountries = ['UG', 'KE'];

const initialRegistrationStep: ApiStep = ApiStep.CreateAccount;

export { testId, layoutInitialHeight, restrictedCountries, initialRegistrationStep };
